'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const AddressIcon = ({ sx }) => {
  return (
    <SvgIcon sx={sx} data-testid="AddressIcon">
      <svg
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        id="Pin-Location-1--Streamline-Ultimate"
        height="24"
        width="24"
      >
        <desc>Pin Location 1 Streamline Icon: https://streamlinehq.com</desc>
        <path
          d="M8.5 7a3.5 3.5 0 1 0 7 0 3.5 3.5 0 1 0 -7 0Z"
          fill="none"
          stroke="#3d517b"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        ></path>
        <path
          d="M12 0.5a6.856 6.856 0 0 1 6.855 6.856c0 3.215 -4.942 11.185 -6.434 13.517a0.5 0.5 0 0 1 -0.842 0c-1.492 -2.332 -6.434 -10.3 -6.434 -13.517A6.855 6.855 0 0 1 12 0.5Z"
          fill="none"
          stroke="#3d517b"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        ></path>
        <path
          d="M17 19.7c3.848 0.324 6.5 1.009 6.5 1.8 0 1.105 -5.148 2 -11.5 2S0.5 22.605 0.5 21.5c0 -0.79 2.635 -1.473 6.458 -1.8"
          fill="none"
          stroke="#3d517b"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        ></path>
      </svg>
    </SvgIcon>
  )
}

AddressIcon.propTypes = {
  sx: PropTypes.object
}
